import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "highlighted-content-text" }

import BankData from '@src/components/shared/BankData.vue';
import IconText from '@src/components/patterns/IconText.vue';
import ContentCard from '@src/components/patterns/ContentCard.vue';
import BankIcon from '@src/components/shared/icons/BankIcon.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'BankInfo',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ContentCard, { "is-sidebar-card": true }, {
    content: _withCtx(() => [
      _createVNode(IconText, { "is-small-heading": true }, {
        icon: _withCtx(() => [
          _createVNode(BankIcon, { class: "highlighted-icon" })
        ]),
        content: _withCtx(() => [
          _createElementVNode("h2", null, [
            _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('bank_data_title_new_prefix')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('bank_data_title')), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(BankData)
    ]),
    _: 1
  }))
}
}

})